import styled from 'styled-components';
import { rem } from 'polished';
import SummaryProfile from '../../../core/SummaryProfile';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import Projects from '../../../core/Projects';

const BoxProjects = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  padding: ${rem('25px')} ${rem('16px')} ${rem('30px')} ${rem('16px')};
  ${mediaqueries.greaterThan('mobile')`
    padding: ${rem('30px')} ${rem('24px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('30px')} 0;
  `};
`;

const OverwriteProjects = styled(Projects)`
  margin: auto;
  max-width: ${rem('1232px')};
`;

export const StyledSummaryProfile = styled(SummaryProfile)`
  clear: both;
  margin-top: ${rem('30px')};

  .contact {
    margin-top: ${rem('-35px')};
  }
`;

export { BoxProjects, OverwriteProjects };
